import React, { Component } from 'react';
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import { Row, Col } from 'react-materialize';
import { Link } from 'react-router-dom';
import '../css/footer.css';

const mapState = { center: [47.227304, 39.753524], zoom: 16 };

const MyPlacemark = () => (
  <YMaps>
    <Map state={mapState} height='400px' width='100%'>

      <Placemark
        geometry={{
          coordinates: [47.227304, 39.753524]
        }}
      />

    </Map>
  </YMaps>
);

class FooterComponent extends Component {
  render() {
    return(
      <div className="footer">
      <Row>
        <Col s={12} m={8} l={8}>
          <MyPlacemark />
        </Col>
        <Col s={12} m={4} l={4} className="footer__content">
          <h5 className="white-text">ООО "Меридиан БКД"</h5>
          <p className="grey-text text-lighten-4">344019, г. Ростов-на-Дону</p>
          <p className="grey-text text-lighten-4">ул. 3-я линия, д. 7/51, к.18-21</p>
          <p className="grey-text text-lighten-4">+7(863)210-65-99, +7(863)210-66-01, +7(960)469-90-90</p>
          <ul>
            <li><Link to='/gallery' className="grey-text text-lighten-3">Галерея</Link></li>
            <li><Link to='/types' className="grey-text text-lighten-3">Типы ограждений</Link></li>
          </ul>
          <p className="grey-text text-lighten-3 copyright">© ООО «Меридиан БКД», 2018</p>
        </Col>
      </Row>

      </div>
    );
  }
}

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/footer.js